import { useBootstrapAccessRole } from 'hooks/Bootstrap/useBootstrapAccessRole';
import { useBootstrapAppSetup } from 'hooks/Bootstrap/useBootstrapApp';
import { useBootstrapAuth } from 'hooks/Bootstrap/useBootstrapAuth';
import { useBootstrapLanguage } from 'hooks/Bootstrap/useBootstrapLanguage';
import { useBootstrapStyle } from 'hooks/Bootstrap/useBootstrapStyle';
import { ReactNode } from 'react';

/**
 * Bootstrap
 * -----------------------------
 * 앱이 시작될 때 딱 한 번만 실행되는 초기 전역 세팅 작업을 담당하는 컴포넌트.
 */
export const Bootstrap = ({ children }: { children: ReactNode }) => {
  // * App Bootstrap
  const isAppReady = useBootstrapAppSetup();

  // * 언어 Bootstrap
  const isLanguageReady = useBootstrapLanguage();

  // * 전역 스타일 Bootstrap
  const isStyleReady = useBootstrapStyle();

  // * 사용자 접근 권한 Bootstrap
  const isAccessRoleReady = useBootstrapAccessRole();

  // * 로그인 및 유저 정보 Bootstrap
  useBootstrapAuth();

  const isAllReady = [isAppReady, isLanguageReady, isStyleReady, isAccessRoleReady].every(Boolean);

  if (!isAllReady) return null;
  return <>{children}</>;
};
